import { ReactNode } from 'react'

/**
 * Duolingo's mascot speech bubble: a rounded 2px-bordered card with a pointer
 * tail aimed at the mascot. The tail sits on the bottom edge when the mascot
 * stands underneath (the full-screen mascot beats) and on the left edge when
 * the mascot sits beside the bubble (every question screen).
 *
 * Each tail is a bordered triangle with a white one laid over it, so the 2px
 * outline continues around the point.
 */
export default function DuoSpeechBubble({
  children,
  tail = 'bottom',
}: {
  children: ReactNode
  tail?: 'bottom' | 'left'
}) {
  return (
    <div className="border-duo-line relative rounded-2xl border-2 bg-white px-5 py-4">
      {children}

      {tail === 'bottom' ? (
        <>
          <span className="border-t-duo-line absolute top-full left-9 block h-0 w-0 border-x-[9px] border-t-[12px] border-x-transparent" />
          <span className="absolute top-full left-9 -mt-[3px] block h-0 w-0 border-x-[9px] border-t-[12px] border-x-transparent border-t-white" />
        </>
      ) : (
        <>
          <span className="border-r-duo-line absolute top-7 right-full block h-0 w-0 border-y-[9px] border-r-[12px] border-y-transparent" />
          <span className="absolute top-7 right-full -mr-[3px] block h-0 w-0 border-y-[9px] border-r-[12px] border-y-transparent border-r-white" />
        </>
      )}
    </div>
  )
}
